<template>
    <b-button
            v-if="$gate.allow('create', 'service')"
            variant="primary"
            @click="showModal = !showModal"
    >
        <fa
            icon="file-import"
            :title="$t('Import services')"
        />

        <b-modal
            v-model="showModal"
            hide-footer
            :title="$t('Import services')"
        >
            <b-form @submit.prevent="handleSubmit">
                <b-form-group>
                    <b-form-file
                        v-model="file"
                        :state="Boolean(file)"
                        plain
                    />
                </b-form-group>

                <ul
                  v-if="errors"
                  class="list-unstyled text-danger"
                >
                  <li v-for="error in errors">
                    {{ error }}
                  </li>

                </ul>

                <div class="text-right">
                    <b-button :disabled="pending || !file" type="submit" variant="primary">
                        {{ $t('Import') }}

                        <b-spinner v-if="pending" small />
                    </b-button>
                </div>
            </b-form>
        </b-modal>
    </b-button>
</template>
<script>
    import {flatten} from "lodash";

    export default {
        name: 'ServicesImportModal',
        props: {
            projectId: {
                type: [Number, String],
                required: true,
            },
        },
        data() {
            return {
                showModal: false,
                file: null,
                pending: false,
                errors: []
            }
        },
        methods: {
            async handleSubmit() {
                if (this.pending) {
                    return
                }

                this.errors = []
                this.pending = true;

                let formData = new FormData();
                formData.append('project_id', this.projectId)
                formData.append('file', this.file);

                try {
                    let response = await this.axios.post('/api/services/import', formData).then(({data}) => data);

                    this.successToast(response.message);

                    this.file = null;
                    this.showModal = false;

                    this.$root.$emit('services-imported')
                } catch(e) {
                    if (!e.response) {
                        throw e;
                    }
                    this.errors = flatten(e.response.data.errors)
                } finally {
                    this.pending = false;
                }

            },
        }
    }
</script>
